<template>
    <b-modal
        v-model="mobilePopup"
        size="lg"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        no-close-on-backdrop
        id="checkoutModal"
    >

        <div class="modal-body">
            <div class="modal-header">
                <div class="flex flex-column align-center">
                    <b-icon-info-circle font-scale="3" class="white-icon"></b-icon-info-circle>
                    <span>Te rugăm să utilizezi un desktop!</span>
                </div>
            </div>
            <p>Din păcate, nu poți accesa aplicația 411POC Sketch de pe un dispozitiv mobil.</p>

        </div>
    </b-modal>
</template>

<script>
import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconInfoCircle} from 'bootstrap-vue';
export default {
    components: {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BIconInfoCircle
    },
    props: {
        mobilePopup: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.modal-body p{
    color: #fff;
    text-align: center;
    margin-top: 15px;
}
.close-button{
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.button-confirm{
    color: #fff;
    font-size: 14px;
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    padding: 5px 10px;
    width: 50%;
}
.button-confirm:hover{
    background: #fff;
    color: #000;
    cursor: pointer;
}
.v-select{
    width: 100%;
    margin: 15px 0;
}
.v-select >>> .vs__dropdown-toggle{
    margin: 0;
    background: transparent;
    border: 1px solid #fff;
    border-radius: 4px;
    width: 100%;
    min-width: 170px;
    padding: 2px;
}
.v-select >>> .vs__selected-options{
    font-size: 14px;
    color: #fff;
    flex-wrap: inherit !important;
    max-height: 35px;
    overflow: hidden;
    align-items: flex-start;
}
.v-select >>> .vs__selected{
    margin: 0;
    padding: 0;
    color: #fff;
}
.v-select >>> .vs__actions{
    padding: 0;
    transform: scale(0.65);
}
.v-select >>> .vs__actions svg{
    color: #fff;
    fill: #fff;
}
.v-select >>> .vs__dropdown-menu{
    background: #343a40;
    font-size: 12px;
}
.v-select >>> .vs__dropdown-option{
    color: #fff;
}
.v-select >>> .vs__dropdown-option:hover{
    background: #545a6f;
}
.v-select >>> .vs__selected-options input{
    color: #fff;
}
.white-icon{
    color: #fff;
    margin-bottom: 20px;
}
</style>